import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal-dialog modal-dialog-centered",
  style: {"min-width":"950px"}
}
const _hoisted_2 = { class: "modal-content px-10 py-10" }
const _hoisted_3 = { class: "border-bottom mb-10 pb-5" }
const _hoisted_4 = { class: "d-flex justify-content-between" }
const _hoisted_5 = { class: "fs-1" }
const _hoisted_6 = { class: "pt-5" }
const _hoisted_7 = { class: "text-end mt-15" }

import { useI18n } from "vue-i18n";
import { ref, reactive } from "vue";
import { FormInstance } from "element-plus";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import TradeServices from "../services/TradeServices";
import { hideModal, showModal } from "@/core/helpers/dom";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChecklistCreate',
  emits: ["eventSubmit"],
  setup(__props, { expose: __expose, emit: emits }) {

const siteId = ref(0);
const { t } = useI18n();
const isLoading = ref(false);
const ChecklistCreateRef = ref(null);
const ruleFormRef = ref<FormInstance>();



const formData = ref<any>({
  name: "",
  accountNumbers: "",
});

const formRule = reactive<any>({
  name: [{ required: true, message: "Please input name", trigger: "blur" }],
  accountNumbers: [
    { required: true, message: "Please input members", trigger: "blur" },
  ],
});

const addChecklist = async (formEl: FormInstance | undefined) => {
  isLoading.value = true;

  try {
    await formEl?.validate((valid) => {
      if (valid) {
        formData.value.accountNumbers = formData.value.accountNumbers
          .split(",")
          .map(Number);

        formData.value.type = 1;
        formData.value.status = 0;

        TradeServices.addChecklist(formData.value);
        MsgPrompt.success(t("tip.submitSuccess")).then(() => {
          emits("eventSubmit");
          clear();
          close();
        });
      } else {
        return false;
      }
    });
  } catch (error) {
    MsgPrompt.error(t("tip.submitError"));
  }
  isLoading.value = false;
};

const clear = () => {
  formData.value = {
    name: "",
    accountNumbers: "",
  };
};

const show = (_siteId) => {
  siteId.value = _siteId;
  showModal(ChecklistCreateRef.value);
};

const close = () => {
  hideModal(ChecklistCreateRef.value);
};

__expose({ show });

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    tabindex: "-1",
    "aria-hidden": "true",
    "aria-modal": "true",
    role: "dialog",
    ref_key: "ChecklistCreateRef",
    ref: ChecklistCreateRef
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("action.addOffsetCheck")), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_form, {
            model: formData.value,
            rules: formRule,
            ref_key: "ruleFormRef",
            ref: ruleFormRef,
            "label-width": "120px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "Name",
                prop: "name"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: formData.value.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.name) = $event)),
                    placeholder: "Name",
                    clearable: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "Members",
                prop: "accountNumbers",
                class: "mt-5"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: formData.value.accountNumbers,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.accountNumbers) = $event)),
                    placeholder: "Separate by Comma",
                    type: "textarea",
                    clearable: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_el_button, {
                  type: "success",
                  disable: isLoading.value,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (addChecklist(ruleFormRef.value)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("action.submit")), 1)
                  ]),
                  _: 1
                }, 8, ["disable"]),
                _createVNode(_component_el_button, {
                  type: "danger",
                  onClick: _withModifiers(close, ["prevent"])
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("action.close")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ])
    ])
  ], 512))
}
}

})